import { __awaiter } from "tslib";
import { SoapLogService } from "@/servicesTs/models/general/soapLog";
const moduleSoapLog = {
    namespaced: true,
    state: {
        loading: false,
        soapLogs: [],
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getSoapLogs(state) {
            return state.soapLogs;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setSoapLogs(state, data) {
            state.soapLogs = data;
        },
    },
    actions: {
        getSoapLogsByInterconsult({ commit }, interconsult_id) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const result = yield SoapLogService.filterByInterconsultId(interconsult_id);
                commit("setSoapLogs", result);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleSoapLog;
